import Vue from 'vue';
import Vuetify,{VSelect,VSimpleTable,VAutocomplete,VDatePicker} from 'vuetify/lib';
import es from 'vuetify/es5/locale/es';

Vue.use(Vuetify,{
  components:{
    VSelect,VSimpleTable,VAutocomplete,VDatePicker
  }
});

export default new Vuetify({
  theme: {
      options: {
        customProperties: true,
      },
    themes: {
      light: {
        //primary: '#ee44aa',
        primary: '#01579B',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107'
      },
    },
  },
    lang: {
      locales: { es },
      current: 'es',
    },
  icons: {
    iconfont: 'md',
  },
});
